(ns common.css)

(def h1 [:font-extrabold :text-3xl])
(def h2 [:font-bold :text-2xl])
(def h3 [:font-medium :text-xl])

(def section [:w-full "md:w-prose-p-5" :p-5
              :border-x :border-b "last:border-b-0"
              :flex :flex-col :gap-y-5])

(def section-title h3)

(def ^:private base-button [:bg-blue-1 :text-neutral-12 "hover:bg-blue-0" :font-bold])
(def button (conj base-button :px-3 :py-2))
(def button-narrow (conj base-button :px-2))

(def link-button ^:tw [:block :px-3 :py-2 :font-medium :text-center
                       :bg-blue-1 :text-neutral-12 :no-underline
                       "hover:bg-blue-0" "hover:text-neutral-12"])

(def secondary-link-button ^:tw [:block :px-3 :py-2 :font-medium :text-center
                                 :border :border-blue-1 :text-blue-1 :no-underline
                                 "hover:border-blue-0" "hover:text-blue-0"])

(def toolbar-button ^:tw [:flex :items-center :gap-x-2 :px-4 :py-2 :rounded-lg
                          :border :border-neutral-4 :bg-neutral-12
                          :text-base :whitespace-nowrap
                          :text-blue-1 "hover:text-blue-0" "hover:bg-neutral-10"])

(def ^:private base-select [:px-3 :py-2 :w-full])
(def select (conj base-select :border :bg-neutral-9 :border-neutral-4))
(def select-active (into base-select ^:tw [:border-2 :bg-blue-3 :border-blue-1
                                           :text-neutral-0 :font-medium]))
(def select-light (conj base-select :border :bg-neutral-12 :border-neutral-4))
(def select-error (conj base-select :border :bg-red-3 :border-neutral-0))

(def input [:w-full :px-1 :bg-neutral-9 :border :border-neutral-4])

(def filter-panel ^:tw [:p-5 :space-y-2])

(def reset-control (into button-narrow ^:tw [:mt-2]))

(def ^:private manual ["xl:w-full" :border-y :max-w-full :mb-3 :text-green-1 :h-5
                       :font-thin :font-extralight "md:hidden" :border-t :mt-4
                       :bg-orange-1 :bg-yellow-2 :text-neutral-10 :text-neutral-0])

; This helps generate classes to put in tailwindcss/manual_selectors.txt
(comment
  (->> (concat h1 h2 h3 section section-title button button-narrow link-button
               select select-active select-light select-error input manual)
       distinct (into [])))
